// generated from 60_971 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const csvImportFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("csv_import_filter"),
  comparison_key: z.enum([
    "7", // 47_382 (77.71%)
    "8", // 13_589 (22.29%)
  ]),
  display_name: z.string(),
  // undefined: 21_016 (34.47%), defined 39_955 (65.53%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
